module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "plat-approve-list"
  }, [_c('div', {
    attrs: {
      "id": "approveState"
    }
  }, _vm._l((_vm.newStateList), function(state, index) {
    return _c('div', {
      key: index,
      staticClass: "nodelist"
    }, [_vm._l((state.steps), function(item, itemIndex) {
      return _c('div', {
        key: itemIndex,
        staticClass: "node"
      }, [_c('i', {
        staticClass: "node-icon",
        class: {
          'icon-approving': item.new_status !== 2 && item.new_status !== 0,
          'icon-approved': item.new_status === 2,
          'icon-submit': item.new_status === 0
        }
      }), _vm._v(" "), _c('ul', [_c('li', {
        staticClass: "owner"
      }, [_vm._v(_vm._s(item['new_userName']))]), _vm._v(" "), _c('li', {
        staticClass: "date"
      }, [_vm._v(_vm._s(item['new_date']))])])])
    }), _vm._v(" "), (index !== _vm.newStateList.length - 1) ? _c('div', {
      staticClass: "proce"
    }, [_c('span', [_vm._v("- - - - - - - ")])]) : _vm._e()], 2)
  }), 0), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$_t('历史记录', 'approval.approveloglist')))]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "approveTrack"
    }
  }, [_c('ul', _vm._l((_vm.trackList), function(track, index) {
    return _c('li', {
      key: track.ew_flowapproval_logId,
      class: {
        last: index === _vm.trackList.length - 1
      }
    }, [_c('i', {
      staticClass: "node-icon",
      class: {
        first: index === 0
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "plat-flow-desc"
    }, [_c('span', {
      staticClass: "date"
    }, [_vm._v(_vm._s(track['new_date']))]), _vm._v(" "), _c('span', {
      staticClass: "action"
    }, [_vm._v("[" + _vm._s(track['new_actionName']) + "]")]), _vm._v(" "), _c('span', {
      staticClass: "step"
    }, [_vm._v(_vm._s(track['new_stepName']))]), _vm._v(" "), _c('span', {
      staticClass: "owner"
    }, [_vm._v(_vm._s(track['new_userName']))])]), _vm._v(" "), _c('div', {
      staticClass: "memo"
    }, [_c('span', [_vm._v(_vm._s(track.new_memo))])])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-85fbe16a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./packages/flowsubmit/src/flow-approval-list.vue
// module id = 2138
// module chunks = 228